module.exports = __webpack_public_path__ + "static/joinourteam.985a5f06.jpg";